import api from './api';

class StockService {
  getStockByInventory = async (inventoryId, page = 1, limit = 10, search = '') => {
    try {
      let url = `/stocks/by-inventory/${inventoryId}?page=${page}&limit=${limit}`;
      
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };
     getStockByInventoryNew = async (inventoryId, page = 1, limit = 1000, search = '') => {
    try {
      let url = `/stocks/by-inventory/${inventoryId}?page=${page}&limit=${limit}`;
      
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };
  searchStock = async (inventoryId, searchTerm, page = 1, limit = 10) => {
    try {
      const response = await api.get(`/by-inventory/${inventoryId}?page=${page}&limit=${limit}&search=${encodeURIComponent(searchTerm)}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  };
  
  handleError = (error) => {
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 400:
          return new Error(data.message || 'Invalid request');
        case 401:
          return new Error('Unauthorized access');
        case 404:
          return new Error('Inventory not found');
        case 500:
          return new Error('Server error');
        default:
          return new Error(data.message || 'Failed to fetch stock data');
      }
    } else if (error.request) {
      return new Error('No response from server. Please check your connection.');
    } else {
      return new Error('Request error: ' + error.message);
    }
  };
}

export default new StockService();
